export default __webpack_public_path__ + "static/media/yellow_shake_cut.3f370718.png";